import action from "../action";
export const SET_TEAM_OPTS = "SET_TEAM_OPTS";
export const SET_OPT_DETAILS = "SET_OPT_DETAILS";
export const SET_CUSTOM_OPT_TYPES = "SET_CUSTOM_OPT_TYPES";
export const SET_CREATE_OPT_PHASE = "SET_CREATE_OPT_PHASE";
export const SET_EVENT_DETAILS = "SET_EVENT_DETAILS";

export const SET_DATA_VIEW_CHALLENGE = "SET_DATA_VIEW_CHALLENGE";
export const SET_PREFILL_FORM = "SET_PREFILL_FORM";
export const SET_PREFILL_FORM_STATE = "SET_PREFILL_FORM_STATE";
export const SET_PARTICIPANTS_VIEW_CHALLENGE =
  "SET_PARTICIPANTS_VIEW_CHALLENGE";
export const SET_UPLOAD_IMG_CHALLENGES = "SET_UPLOAD_IMG_CHALLENGES";
export const SET_CHALLENGES_IMG_NAME = "SET_CHALLENGES_IMG_NAME";
export const SET_DAYS_LEFT = "SET_DAYS_LEFT";
export const SET_BAR_DATA_LEFT_PERCENTAGE = "SET_BAR_DATA_LEFT_PERCENTAGE";
export const SET_BAR_DAYS_LEFT_PERCENTAGE = "SET_BAR_DAYS_LEFT_PERCENTAGE";
export const SET_EDIT_CHALLENGE = "SET_EDIT_CHALLENGE";
export const SET_USE_TEMPLATE = "SET_USE_TEMPLATE";

export const set_team_opts = (data) =>
  action({
    type: SET_TEAM_OPTS,
    data
  });
export const set_opt_details = (data) =>
  action({
    type: SET_OPT_DETAILS,
    data
  });
export const set_custom_opt_types = (data) =>
  action({
    type: SET_CUSTOM_OPT_TYPES,
    data
  });
export const set_create_opt_phase = (data) =>
  action({
    type: SET_CREATE_OPT_PHASE,
    data
  });
export const set_event_details = (data) =>
  action({
    type: SET_EVENT_DETAILS,
    data
  });

export const set_parcipantsViewChallenge = (data) =>
  action({
    type: SET_PARTICIPANTS_VIEW_CHALLENGE,
    data
  });
export const set_uploadedImgUrl = (data) =>
  action({
    type: SET_UPLOAD_IMG_CHALLENGES,
    data
  });
export const set_uploadedImgName = (data) =>
  action({
    type: SET_CHALLENGES_IMG_NAME,
    data
  });
export const set_dataViewChallenge = (data) =>
  action({
    type: SET_DATA_VIEW_CHALLENGE,
    data
  });
export const set_prefillFormState = (data) =>
  action({
    type: SET_PREFILL_FORM_STATE,
    data
  });
export const set_prefilledFormObject = (data) =>
  action({
    type: SET_PREFILL_FORM,
    data
  });
export const set_daysLeftChallenget = (data) =>
  action({
    type: SET_DAYS_LEFT,
    data
  });
export const set_barDataLeftPercentage = (data) =>
  action({
    type: SET_BAR_DATA_LEFT_PERCENTAGE,
    data
  });
export const set_barDaysLeftPercentage = (data) =>
  action({
    type: SET_BAR_DAYS_LEFT_PERCENTAGE,
    data
  });
export const set_editChallenge = (data) =>
  action({
    type: SET_EDIT_CHALLENGE,
    data
  });
export const set_useTemplate = (data) =>
  action({
    type: SET_USE_TEMPLATE,
    data
  });
